<input
  #fileInput
  hidden
  type="file"
  [multiple]="multiple"
  [accept]="allowedMIMETypes.join(',')"
  (change)="fileUploaded($event)"/>

@if (type === 'button') {
  <button
    matRipple
    class="mc-button mc-button_blue"
    (click)="openDialogUpload()">
    <span class="material-icons attach-icon">attach_file</span>
    {{ 'common.attach' | translate }}
  </button>
} @else if (type === 'icon') {
  <span class="material-icons file-icon" (click)="openDialogUpload()">attach_file</span>
} @else {
  <div class="file-field" (click)="openDialogUpload()">
    @if (urlImg) {
      <span class="material-icons file-field__icon" (click)="removeFiles(); $event.stopPropagation();">cancel</span>
      <img class="file-field__img" [src]="urlImg">
    } @else {
      {{ 'common.avatar' | translate }}
    }
  </div>
}
